import { Routes, Route, Navigate } from 'react-router-dom';
import FeatureErrorBoundary from 'components/errorBoundary/FeatureErrorBoundary';
import Dashboard from 'pages/cantrackDashboard/Dashboard';
import Cases from 'pages/cases/Cases';
import CaseDetail from 'pages/cases/CaseDetail';
import CasePrint from 'pages/cases/CasePrint';
import Comments from 'pages/comments/Comments';
import KeywordManagement from 'pages/keywordManagement/KeywordManagement';
import ActivityLogManagement from 'pages/activityLogManagement/ActivityLogManagement';
import PayrollReport from 'pages/payrollReport/PayrollReport';
import TimesheetsRich from 'pages/timesheets/TimesheetsRich';
import SREDReport from 'pages/sredReport/SREDReport';

function CANtrack() {
  return (
    <Routes>
      <Route
        index
        element={
          <FeatureErrorBoundary featureName="Dashboard">
            <Dashboard />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="dashboard"
        element={
          <FeatureErrorBoundary featureName="Dashboard">
            <Dashboard />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="cases"
        element={
          <FeatureErrorBoundary featureName="Cases">
            <Cases />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="cases/:caseId"
        element={
          <FeatureErrorBoundary featureName="Case Detail">
            <CaseDetail />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="cases/:caseId/print"
        element={
          <FeatureErrorBoundary featureName="Case Print">
            <CasePrint />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="print"
        element={
          <FeatureErrorBoundary featureName="Case Print">
            <CasePrint />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="comments"
        element={
          <FeatureErrorBoundary featureName="Comments">
            <Comments />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="keyword-management"
        element={
          <FeatureErrorBoundary featureName="Keyword Management">
            <KeywordManagement />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="activity-log-management"
        element={
          <FeatureErrorBoundary featureName="Activity Log Management">
            <ActivityLogManagement />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="payroll"
        element={
          <FeatureErrorBoundary featureName="Payroll Report">
            <PayrollReport />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="timesheet"
        element={
          <FeatureErrorBoundary featureName="Timesheets (Rich)">
            <TimesheetsRich />
          </FeatureErrorBoundary>
        }
      />
      <Route
        path="sred"
        element={
          <FeatureErrorBoundary featureName="SRED Report">
            <SREDReport />
          </FeatureErrorBoundary>
        }
      />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}

export default CANtrack;
